export default {
	'01': {
		'name': 'Січня',
		'short': 'Jan',
		'number': 1,
		'days': 31,
	},
	'02': {
		'name': 'Лютий',
		'short': 'Feb',
		'number': 2,
		'days': 28,
	},
	'03': {
		'name': 'Березень',
		'short': 'Mar',
		'number': 3,
		'days': 31,
	},
	'04': {
		'name': 'Квітень',
		'short': 'Apr',
		'number': 4,
		'days': 30,
	},
	'05': {
		'name': 'Травень',
		'short': 'May',
		'number': 5,
		'days': 31,
	},
	'06': {
		'name': 'Червень',
		'short': 'Jun',
		'number': 6,
		'days': 30,
	},
	'07': {
		'name': 'Липень',
		'short': 'Jul',
		'number': 7,
		'days': 31,
	},
	'08': {
		'name': 'Серпня',
		'short': 'Aug',
		'number': 8,
		'days': 31,
	},
	'09': {
		'name': 'Вересень',
		'short': 'Sep',
		'number': 9,
		'days': 30,
	},
	'10': {
		'name': 'Жовтень',
		'short': 'Oct',
		'number': 10,
		'days': 31,
	},
	'11': {
		'name': 'Листопад',
		'short': 'Nov',
		'number': 11,
		'days': 30,
	},
	'12': {
		'name': 'Грудень',
		'short': 'Dec',
		'number': 12,
		'days': 31,
	},
}
